import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ReAcquisitionHelper } from '../../../../helper/re-acquisition-helper/re-acquisition-helper';
import { EventLoggerService } from '@services/event-logger-service';
import { ConnectionService } from '@services/connection-service';

@Component({
  selector: 're-acquisition-user-query-bottom-sheet',
  imports: [CommonModule, FormsModule],
  templateUrl: './re-acquisition-user-query-bottom-sheet.component.html',
})
export class ReAcquisitionUserQueryBottomSheetComponent implements OnInit {

  userQuery: string = "";
  invalidUserInputError: string = "";
  user: Table.User;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private readonly bottomSheetRef: MatBottomSheetRef,
    private readonly reAcquisitionHelper: ReAcquisitionHelper,
    private readonly eventLogger: EventLoggerService,
    private readonly connectionService: ConnectionService,
  ) {}

  ngOnInit(): void {
    this.user = this.connectionService.getActingUser();
    this.eventLogger.cleverTapEvent('pageOpen', JSON.stringify({ pageName: 'reacquisition_user_issue_description', type: 'bottom_sheet' }));
  }

  async onContinue(): Promise<void> {
    const validation = this.reAcquisitionHelper.validateUserQuery(this.userQuery, this.user?.get('languagePreference'));
    if (!validation.valid) {
      this.invalidUserInputError = validation.error;
      return;
    }
    this.data.onContinue(this.userQuery);
    this.bottomSheetRef.dismiss();
  }

  handleOnChange(): void {
    if (this.userQuery.length > this.reAcquisitionHelper.MIN_QUERY_LENGTH || !this.userQuery.length) {
      this.invalidUserInputError = '';
    }
  }
}
